import type { EncounterScrubberResult } from './types';

export type ScrubberSuggestionDecision = 'accept' | 'reject';

export function scrubberResultRowKey(result: EncounterScrubberResult, index: number): string {
  return `${index}-${result.code}-${result.action}-${result.message.slice(0, 48)}`;
}

/** Results the provider must accept or reject before save. */
export function scrubberResultsNeedUserReview(
  results: EncounterScrubberResult[],
): EncounterScrubberResult[] {
  return results.filter(
    (r) =>
      r.severity === 'warning' ||
      r.action === 'suggest_replace' ||
      r.action === 'suggest_remove' ||
      r.action === 'suggest_add' ||
      r.action === 'flag_unsupported' ||
      r.action === 'billing_review',
  );
}
